module.exports = __webpack_public_path__ + "img/qcks_rf_main.3156773c.jpg";